import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ellipsis-horizontal-circle",
  "use": "icon-ellipsis-horizontal-circle-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" class=\"ionicon\" viewBox=\"0 0 512 512\" id=\"icon-ellipsis-horizontal-circle\"><title>Ellipsis Horizontal Circle</title><circle cx=\"256\" cy=\"256\" r=\"26\" /><circle cx=\"346\" cy=\"256\" r=\"26\" /><circle cx=\"166\" cy=\"256\" r=\"26\" /><path d=\"M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z\" fill=\"none\" stroke=\"currentColor\" stroke-miterlimit=\"10\" stroke-width=\"32\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol